var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "image-input" }, [
    _c("div", { staticClass: "image-input-uploader" }, [
      _c(
        "div",
        { staticClass: "image-input__image" },
        [
          _vm.imageSrc
            ? _c("img", {
                staticClass: "image-input__image",
                attrs: { src: _vm.imageSrc }
              })
            : _vm._t("placeholder")
        ],
        2
      ),
      _c("div", { staticClass: "center" }, [
        _c("div", { staticClass: "row justify-center" }, [
          _c(
            "div",
            { staticClass: "col-6 text-center" },
            [
              _c(
                "q-btn",
                {
                  attrs: { color: "white", round: "", flat: "" },
                  on: {
                    click: function($event) {
                      _vm.$refs.fileInput.click()
                    }
                  }
                },
                [
                  _c("q-icon", {
                    attrs: { name: "cloud_upload", size: "2.5rem" }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.deleteEndpoint && (_vm.imageUrl || _vm.image),
                  expression: "deleteEndpoint && (imageUrl || image)"
                }
              ],
              staticClass: "col-6 text-center"
            },
            [
              _c(
                "q-btn",
                {
                  attrs: { color: "white", round: "", flat: "" },
                  on: { click: _vm.handleImageDelete }
                },
                [_c("q-icon", { attrs: { name: "delete", size: "2.5rem" } })],
                1
              )
            ],
            1
          )
        ])
      ]),
      _c("input", {
        ref: "fileInput",
        staticClass: "hidden file-input",
        attrs: { type: "file", accept: "image/jpeg,image/png" },
        on: { change: _vm.handleImageChanged }
      }),
      _vm.showHint
        ? _c("label", { staticClass: "hint text-center" }, [
            _c("small", { staticClass: "uppercase" }, [
              _vm._v(_vm._s(_vm.$t("image_hint")))
            ])
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }